import { createContext, useContext } from "react";

export const ProcessContext = createContext(null);

export function useProcess() {
  const ctx = useContext(ProcessContext);
  if (!ctx) throw new Error("useProcess must be used within ProcessContext.Provider");
  return ctx;
}
